export const getCreatedByFormattedValue = (value: string): string => {
  const seperatedDataByEndPoint = value.split(":");
  const isSeperatedByEndPoint = seperatedDataByEndPoint?.length > 1;
  const lastSeperatedItem = seperatedDataByEndPoint.at(-1);

  return `${isSeperatedByEndPoint ? "..." : ""}${lastSeperatedItem}`;
};
